import { useTranslation } from 'react-i18next';
import ProductCard from '../main_compos/ProductCard';
import { useEffect, useState } from 'react';
import axios from 'axios';

export default function NewArrivalsSection() {
  const { t } = useTranslation();
  const localhost = process.env.REACT_APP_LOCALHOST;
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(localhost + 'all-new-arrivals');
      // endpoint is paginated -> data lives in res.data.data
      const list = Array.isArray(res.data?.data) ? res.data.data : Array.isArray(res.data) ? res.data : [];
      const updated = list.map((item) => ({
        ...item,
        category: item.category ? JSON.parse(item.category) : null,
        imgs: item.imgs ? JSON.parse(item.imgs) : null,
      }));
      setProducts(updated.slice(0, 8));
    } catch (error) {
      // console.error('Error fetching new arrivals:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="min-h-[45vh] flex justify-center items-center">
        <div className="loading-spinner" />
      </div>
    );
  }

  if (products.length === 0) return null;

  return (
    <section className="pt-12 sm:pt-16 lg:pt-20">
      <div className="max-w-[1600px] mx-auto px-3 sm:px-6">
        <div className="mb-6">
          <h2 className="text-2xl max-sm:text-xl font-bold text-gray-900 sm:text-3xl">{t('new-arrivals')}</h2>
          <p className="text-base max-sm:text-sm text-gray-600">{t('our-new-collection')}</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-3 sm:gap-x-4 gap-y-8 sm:gap-y-10">
          {products.map((item, index) => (
            <ProductCard key={index} item={item} />
          ))}
        </div>

        <div className="w-full flex justify-center items-center mt-10">
          <a href="/new-arrivals" className="px-8 py-3 text-sm uppercase tracking-wider font-medium text-white bg-black rounded-full hover:bg-black/85 transition-all duration-300">
            {t('view-all')}
          </a>
        </div>
      </div>
    </section>
  );
}
